export default "__VITE_ASSET__CDaJ7cuT__"